import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Button, Stack } from '@mui/material'
import React from 'react'
import { useFieldArray, useWatch } from 'react-hook-form'
import { SettingsBox } from 'src/Elements/Data'
import { InfoText } from 'src/Libs/flow/components'
import { AddIcon } from 'src/Libs/flow/icons'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { createDefaultBlockingTime, getScheduleConflicts } from '../../utils/blocking-times-utils'
import { BlockingTimesSchedule } from './BlockingTimesSchedule'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'

export const ChargeBlockingTimes: React.FC = () => {
  const { t } = useCustomTranslation()
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()

  const { control } = useInstallationForm()

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'storageSystem.generalSettings.advancedSettings.chargeBlockingWeeklySchedule',
  })
  const chargeBlockingWeeklySchedule = useWatch({
    control,
    name: 'storageSystem.generalSettings.advancedSettings.chargeBlockingWeeklySchedule',
  })

  const validatedSchedules = getScheduleConflicts(chargeBlockingWeeklySchedule)

  return (
    <Box component={'section'}>
      <SettingsBox title={t('installation.batteryBlockingTime.charge')} description={t('installation.batteryBlockingTime.chargeDescription')}>
        <Box>
          {fields.length === 0 ? (
            <InfoText>{t('energyManagement.chargingBlockTimes.notAvailable')}</InfoText>
          ) : (
            <Stack>
              {fields.map((item, index) => (
                <BlockingTimesSchedule
                  blockingTimeType="chargeBlockingWeeklySchedule"
                  key={item.id}
                  index={index}
                  remove={() => remove(index)}
                  conflictingScheduleIndex={validatedSchedules[index]?.conflictingScheduleIndex}
                />
              ))}
            </Stack>
          )}
        </Box>
        {canEdit && (
          <Button
            variant="outlined"
            color="secondary"
            size="large"
            startIcon={<AddIcon />}
            onClick={() => append(createDefaultBlockingTime(), { shouldFocus: false })}
            sx={{
              ml: 'auto',
              width: { xs: '100%', sm: 'fit-content' },
            }}
          >
            {t('common.add')}
          </Button>
        )}
      </SettingsBox>
    </Box>
  )
}
